<template>
  <div id="app" v-show="isJump">
    <router-view/>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
export default {
  name: 'App',
  data () {
    return {
      isJump: false,
      height: null
    }
  },
  methods: {
    wechatInit () {
      let req = {url: location.href}
      let shareUrl = 'http://spage.haimati.cn/ningboOL/index.html'
      let getUrl = 'http://vote.mantusy.com/index.php/Wechat/getWechatSign'
      this.$axios.get(getUrl, {params: req}).then((res) => {
        let signPackage = res.data.msg
        wx.config({
          debug: false,
          appId: signPackage.appId,
          timestamp: signPackage.timestamp,
          nonceStr: signPackage.nonceStr,
          signature: signPackage.signature,
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
        })
        wx.ready(() => {
          wx.onMenuShareTimeline({
            title: '再忙也别忘了“精致”，海马体宁波OL改造计划正式开启！',
            link: shareUrl,
            imgUrl: 'http://vote.cdn.mantusy.com/unit/reformPlan-logo.jpg',
            success: function () {
              return true
            },
            cancel: function () {
              return true
            }
          })
          wx.onMenuShareAppMessage({
            title: '再忙也别忘了“精致”，海马体宁波OL改造计划正式开启！',
            desc: '30位职场女性正在招募中~',
            link: shareUrl,
            imgUrl: 'http://vote.cdn.mantusy.com/unit/reformPlan-logo.jpg',
            type: 'link',
            dataUrl: '',
            success: function () {
              return true
            },
            cancel: function () {
              return true
            }
          })
        })
      })
    },
    getUserInfo (key) {
      let getUrl = 'http://auth.haimati.cn/getInfo.php'
      let getData = {
        key,
        type: 'advance'
      }
      this.$indicator.open()
      this.$axios.get(getUrl, {params: getData}).then(res => {
        if (res.data.code === 200) {
          this.$indicator.close()
          let userInfo = {
            headimgurl: res.data.data.headimgurl,
            openid: res.data.data.openid,
            sex: res.data.data.sex
          }
          this.$store.commit('setUserInfo', userInfo)
        } else {
          location.href = 'http://spage.haimati.cn/birthdayBlessing/index.html'
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取微信key
    init () {
      let authKey = this.getQueryString('key')
      if (!authKey) {
        let url = location.href.replace(/http:\/\//, '')
        window.location.href = '//auth.haimati.cn/advance_http.php?back=' + url
      } else {
        this.isJump = true
        this.wechatInit()
        this.getUserInfo(authKey)
      }
    },
    getQueryString (name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      let r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      }
      return null
    },
    needGetUserInfo () {
      // 判断是否为微信
      // 微信 - 鉴权
      // 非微信 - 正常页面展示
      let agent = window.navigator.userAgent.toLowerCase()
      if (/micromessenger/.test(agent)) {
        this.init()
      } else {
        this.isJump = true
      }
    }
  },
  created () {
    // 需要微信鉴权的活动
    // this.needGetUserInfo()

    // 不需要微信鉴权的活动
    this.isJump = true
    this.wechatInit()

    // 初始化rem
    document.documentElement.style.fontSize = document.documentElement.clientWidth / 10 + 'px'
  }
}
</script>

<style>
* {
  box-sizing: border-box;
  background-size: 100% 100%;
}
body {
  margin: 0;
  padding: 0;
  /* background-color: #eaced0; */
}
#app {
  font-family: "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei";
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-overflow-scrolling : touch;
  /* background-color: #eaced0; */
  text-align: center;
  color: #083760;
}
select {
  -moz-appearance: none;
  -webkit-appearance: none;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue